﻿import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalTransfer`,
  scopes: ExtHubRequest,
});

api.createEntities([{ name: 'GetFile' }, { name: 'GetSharepointFile' }]);

const GetFile = (body) => api.endpoints.GetFile.post(body);
const GetSharepointFile = (body) => api.endpoints.GetSharepointFile.post(body);

export { GetFile, GetSharepointFile };
